// action type
export const GET_BLOGTAG = 'CmnBlog_GET_BLOGTAG';

//reducer
const initialState = {
    blogTagId: 0
};

export function CmnBlogReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BLOGTAG:
      return action.payload;
    default:
      return state;
  }
}

//action
export function changeBlogTag(blogTagId) {
  return {
    type: GET_BLOGTAG,
    payload: {blogTagId: blogTagId}
};
}




// WEBPACK FOOTER //
// ./src/redux/CmnBlog.js